import { extractAxiosErrorDetail } from '@heidi/api/errors';
import { defineMessages, type IntlShape } from 'react-intl';

const projectChatErrorMessages = defineMessages({
  rateLimited: {
    defaultMessage: "You're sending messages too quickly. Wait a minute and try again.",
    id: 'uU80iAtcuD',
    description: 'Error shown when a Heidi Work message is rate limited',
  },
});

/** Internal provisional-handoff settlement; never shown as a user error. */
export class ProvisionalSubmitRejectedError extends Error {
  readonly restoreDraft: boolean;

  constructor(options: { restoreDraft?: boolean } = {}) {
    super('Provisional submit rejected');
    this.name = 'ProvisionalSubmitRejectedError';
    this.restoreDraft = options.restoreDraft ?? true;
  }
}

export const getSubmitTurnErrorMessage = (error: unknown, intl: IntlShape): string => {
  const status = (error as { response?: { status?: number } })?.response?.status;
  if (status === 429) {
    return intl.formatMessage(projectChatErrorMessages.rateLimited);
  }
  return (
    extractAxiosErrorDetail(error) ??
    (error instanceof Error ? error.message : 'Unknown error')
  );
};

// Stop the computer-use child first for prompt, run-scoped executor shutdown,
// then stop the parent turn so it cannot continue after the cancelled task.
// `cancelComputerUseRun` is the app's native cancel, bound by each caller.
export const resolveDesktopToolCancel = (
  isSubAgentDesktopCall: boolean,
  childAgentRunId: string | undefined,
  cancelParentTurn: (() => void) | undefined,
  cancelComputerUseRun: (agentRunId: string) => void
): (() => void) | undefined => {
  if (isSubAgentDesktopCall) {
    return childAgentRunId
      ? () => {
          cancelComputerUseRun(childAgentRunId);
          cancelParentTurn?.();
        }
      : cancelParentTurn;
  }
  return undefined;
};
